module.exports = __webpack_public_path__ + "img/gather ruffle.b36673cb.png";